import { render, staticRenderFns } from "./BrandCooperationBox.vue?vue&type=template&id=1d7ef3b2&scoped=true&"
import script from "./BrandCooperationBox.vue?vue&type=script&lang=js&"
export * from "./BrandCooperationBox.vue?vue&type=script&lang=js&"
import style0 from "./BrandCooperationBox.vue?vue&type=style&index=0&id=1d7ef3b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7ef3b2",
  null
  
)

export default component.exports